import { useTranslation } from "react-i18next";

const badges = [
  { icon: "ri-refresh-line", key: "trust.updated" },
  { icon: "ri-book-open-line", key: "trust.expert" },
  { icon: "ri-scales-line", key: "trust.comparison" },
  { icon: "ri-shield-check-line", key: "trust.safety" },
];

export default function TrustBadges() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-8 border-b border-background-200/70">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {badges.map((badge) => (
            <div key={badge.key} className="flex items-center gap-2.5 text-foreground-600">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${badge.icon} text-accent-600 text-sm`}></i>
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{t(badge.key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}